var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-payment-confirm",
        title: _vm.$t("Confirmar pagamento"),
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-header-close": "",
        "hide-footer": "",
        centered: "",
      },
      on: { hidden: _vm.resetModal },
    },
    [
      _c(
        "FormulateForm",
        {
          ref: "formPaymentConfirm",
          attrs: { name: "formPaymentConfirm" },
          on: { submit: _vm.onConfirm },
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "modal_payment_confirm-input_nsu",
                          name: "nsu",
                          type: _vm.isPdvAtm ? "osk-text" : "number",
                          validation: "required|matches:/^[1-9][0-9]*/",
                          placeholder: _vm.$t("0000000"),
                          label: _vm.$t(
                            "Código de Autorização (NSU da Autorizadora)"
                          ),
                          "osk-type": "numeric",
                        },
                        model: {
                          value: _vm.form.nsu,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nsu", $$v)
                          },
                          expression: "form.nsu",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c(
                    "b-col",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _c("e-button", {
                        staticClass: "mr-1",
                        attrs: {
                          id: "modal_payment_confirm-btn_cancel",
                          variant: "danger",
                          text: _vm.$t("Cancelar"),
                          "text-shortcuts": _vm.showShortcuts ? ["ESC"] : [],
                        },
                        on: { click: _vm.hideModal },
                      }),
                      _c("e-button", {
                        attrs: {
                          id: "modal_payment_confirm-btn_confirm",
                          variant: "primary",
                          type: "submit",
                          text: _vm.$t("Confirmar"),
                          "text-shortcuts": _vm.showShortcuts
                            ? ["CTRL", "ENTER"]
                            : [],
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }